<template>
  <div class="row tabs">
    <div class="tab" v-for="(item, index) in tabs" :key="index"
      :class="{'active': index === activeIndex}" 
      @click="onTabClick(item, index)">{{item}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    activeTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  methods: {
    onTabClick(item, index) {
      this.activeIndex = index;
      this.$emit('change', {
        item,
        index
      });
    }
  },
  mounted() {
    this.activeIndex = this.activeTabIndex;
  }
};
</script>

<style lang="scss" scoped>
.tabs { 
  border: solid 1px #f7f7fa;
  border-radius: 2px;
  background-color: #f7f8fc;
  overflow: hidden;
  .tab {
    padding: 4px 10px;
    font-size: 12px;
    color: #747990;
    cursor: pointer;
    &.active {
      font-weight: 500;
      color: #171f46;
      background-color: #ffffff;
    }
  }
}
</style>

